/* import __COLOCATED_TEMPLATE__ from './section.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { type UserField, type TicketField } from 'embercom/objects/standalone/data-fields/common';
import type ExternalFieldIdentifier from 'embercom/models/standalone/external-field-identifier';

type Field = UserField | TicketField | ExternalFieldIdentifier;

interface Signature {
  Args: {
    title: string;
    isLoading: boolean;
    fields: Array<Field>;
    selectedField: Field | undefined;
    selectField: (field: Field) => void;
    unsynchronizedFields: Array<Field>;
    synchronizeField: (field: Field) => void;
  };
}

export default class DataFieldSection extends Component<Signature> {
  @tracked filter = '';

  get filteredUnsynchronizedFields() {
    return this.args.unsynchronizedFields.filter((field) =>
      field.name.toLowerCase().includes(this.filter.toLowerCase()),
    );
  }

  @action clearFilter() {
    this.filter = '';
  }

  @action updateFilter(event: KeyboardEvent & { target: HTMLInputElement }) {
    this.filter = event.target?.value;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::DataField::Section': typeof DataFieldSection;
  }
}
